<template>
	<div>
		<div class="steps">
			<div class="step" v-for="(step, i) in steps" :key="i" :class="{ done: currentStatusIndex > i, current: currentStatusIndex == i }">
				<div class="circle">
					<i class="icon icon-check-bold"></i>
				</div>
				<div class="info">
					<span class="title">{{ step.title }}</span>
					<span class="titleDone">{{ step.titleDone }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OrderStatusSteps',
	props: ['currentStatus'],
	data() {
		return {
			steps: [
				{
					status: 'ON',
					key: 'AWAITING_PAYMENT',
					title: 'Pendiente de pago',
					titleDone: 'Pago realizado',
				},
				{
					status: 'PENDING',
					key: 'PROCESSING',
					title: 'En proceso',
					titleDone: 'Pedido procesado',
				},
				{
					status: 'PENDING',
					key: 'READY_TO_SHIP',
					title: 'Pendiente de enviar',
					titleDone: 'Pronto para enviar',
				},
				{
					status: 'PENDING',
					key: 'DELIVERED',
					title: 'Pendiente de entrega',
					titleDone: 'Entregado',
				},
			],
		}
	},
	computed: {
		currentStatusIndex() {
			return this.steps.findIndex((s) => s.key == this.currentStatus)
		},
	},
}
</script>

<style scoped>
.steps {
	display: flex;
	justify-content: space-between;
	padding: 32px 0px;
	max-width: 800px;
	margin: auto;
}
.steps .step {
	display: flex;

	align-items: center;
	flex-direction: column;
	flex-grow: 1;
	position: relative;
}
.steps .step .circle {
	width: 28px;
	height: 28px;
	border-radius: 14px;
	background-color: #f3f3f3;
	display: flex;
	justify-content: center;
	align-items: center;
}
.steps .step .circle .icon {
	opacity: 0.6;
	width: 18px;
	height: 18px;
}
.steps .step .info {
	text-align: center;
}
.steps .step:after {
	content: ' ';
	position: absolute;
	width: 50%;
	height: 8px;
	background-color: #f3f3f3;
	z-index: -1;
	top: 10px;
	left: calc(50% - 0px);
}
.steps .step:before {
	content: ' ';
	position: absolute;
	width: 50%;
	height: 8px;
	background-color: #f3f3f3;
	z-index: -1;
	top: 10px;
	right: calc(50% - 0px);
}

.steps .step.done .circle {
	background-color: #5ee60f;
}
.steps .step.current .circle {
	background-color: #3a78c9;
}

.steps .step.current .circle .icon {
	filter: invert(1);
	opacity: 1;
}
.steps .step.done .circle .icon {
	filter: invert(1);
	opacity: 1;
}

.steps .step.done:after {
	background-color: #5ee60f;
}
.steps .step.done:before {
	background-color: #5ee60f;
}

.steps .step.current:before {
	background-color: #5ee60f;
}
.steps .step.current:after {
	background-color: #f3f3f3;
}

.steps .step:first-child:before {
	display: none;
}
.steps .step:last-child:after {
	display: none;
}

.step .title,
.step .titleDone {
	display: none;
}
.step.current .title {
	display: block;
}
.step.done .titleDone {
	display: block;
}
</style>
